// extracted by mini-css-extract-plugin
export var coachContainer = "index-module--coachContainer--+rH2Q";
export var leftContainer = "index-module--leftContainer--tWHnv";
export var profileContainer = "index-module--profileContainer--7+noV";
export var details = "index-module--details--7dxvp";
export var weshooterBadge = "index-module--weshooterBadge--kT4ot";
export var icon = "index-module--icon--Kf3KT";
export var bio = "index-module--bio--QGHnC";